import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { linkPage } from "@utils/router";
import { VscHistory } from "react-icons/vsc";

import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { HomeService } from "@services/home.service";
import { Spiner } from "@components/loaders/spiner";
import { toRp } from "@utils/helper";
import { Mading } from "@services/dtos/home.dto";
import { useThemeStore } from "@stores/theme.store";
import { androidIsAvailableBiometric } from "@utils/android";
import "@splidejs/react-splide/css";
import moment from "moment";

import LogoHomePage from "@assets/images/logo-khoiriyah.png";
import {
  FcBusinessContact,
  FcList,
  FcMenu,
  FcMoneyTransfer,
  FcPlus,
  FcShop,
  FcTodoList,
} from "react-icons/fc";
import { BiTransfer } from "react-icons/bi";

export const DashboardPage = () => {
  const navigate = useNavigate();
  const { setAppBar } = useThemeStore((state) => state);

  const kategori = "*";
  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";
  // const gender = dataNis?.data?.gender ?? "";

  const { data: dataUangSaku, isPending: isPendingUangSaku } = useQuery({
    queryKey: [HomeService.queries.GET_BILLS_AND_BALANCES, nis],
    queryFn: () => HomeService.billsAndBalances({ nis }),
  });

  const { data: dataMading, isPending: isPendingMading } = useQuery({
    queryKey: [HomeService.queries.GET_MADING, kategori, "5"],
    queryFn: () => HomeService.mading(kategori, "5"),
  });

  useEffect(() => {
    // const setupUnreadInbox = setTimeout(() => androidUnreadInbox(), 1000);
    const setupBiometric = setTimeout(() => {
      localStorage.setItem("is-biometric", "false");
      androidIsAvailableBiometric();
    }, 1000);

    return () => {
      clearTimeout(setupBiometric);
      // clearTimeout(setupUnreadInbox);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setAppBar({ title: "Beranda", show: true, leading: "home" });
  }, [setAppBar]);

  const openDetailMading = (detailMading: Mading) => {
    navigate(linkPage.MADING_DETAIL, { state: detailMading });
  };

  return (
    <>
      {/* Profile */}
      <div className="profile-header">
        <div className="tw-pt-[20px] tw-pb-[10px] tw-px-4 tw-flex tw-items-center">
          <div className="tw-grow">
            <div className="tw-flex tw-items-center">
              <div className="tw-text-primary tw-text-xl tw-font-bold">
                <img src={LogoHomePage} alt="" className="tw-h-[65px]" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end of Profile */}

      {/* Pocket */}
      <div className="tw-px-4 tw-mt-4 tw-mb-6 tw-flex tw-items-center">
        <div className="tw-w-2/3 ">
          <div className="tw-text-xs tw-text-text-primary tw-tracking-wide tw-mb-3">
            Uang saku tersisa
          </div>
          <div className="tw-text-2xl tw-font-semibold tw-text-primary">
            {isPendingUangSaku ? (
              <Spiner className="" />
            ) : (
              toRp(dataUangSaku?.data?.saldo ?? 0)
            )}
          </div>
        </div>

        <div className="tw-w-1/3 tw-py-2 tw-mx-auto tw-flex tw-justify-center">
          <div
            onClick={() =>
              navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "topup"), {
                state: {
                  tagihan: false,
                  tipe: "topup",
                },
              })
            }
            className="tw-w-1/2 tw-text-center tw-items-center"
          >
            <BiTransfer className="tw-text-primary tw-text-[28px] card-icon" />
            <div className="tw-mt-2 card-name">Top-up</div>
          </div>

          <div
            onClick={() => navigate(linkPage.FINANCE_POCKET)}
            className="tw-w-1/2 tw-text-center tw-items-center"
          >
            <VscHistory className="tw-text-primary tw-text-[28px] card-icon" />
            <div className="tw-mt-2 card-name">Riwayat</div>
          </div>
        </div>
      </div>
      {/* end of Pocket */}

      {/* Menu */}
      <div
        // className="tw-list-item tw-list-none tw-whitespace-nowrap tw-overflow-x-auto tw-mx-4 tw-mb-4 menu"
        // style={{
        //   msOverflowStyle: "none",
        //   scrollbarWidth: "none",
        // }}
        className="tw-mb-4 tw-px-4"
      >
        <div className="tw-px-2 tw-pb-0 card-body card-body-grid">
          <div className="card-grid">
            <div
              onClick={() => navigate(linkPage.INFO_BIOGRAPH)}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#f5e9ff]" />
              <FcBusinessContact className="card-icon tw-text-accent-primary" />
              <div className="card-name">Biodata</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div onClick={() => navigate(linkPage.HEALTH_PAGE)}>
              <div className="bg-rotated tw-absolute tw-bg-[#e0f9f2]" />
              <FcPlus className="card-icon tw-text-[#00b894] tw-relative tw-z-10" />
              <div className="card-name">Kesehatan</div>
            </div>
          </div>

          <div className="card-grid">
            <div onClick={() => navigate("/school/tahfidz")} className="tw-m-0">
              <div className="bg-rotated tw-absolute tw-bg-[#e0f9f2]" />
              <FcTodoList className="card-icon tw-text-[#00b894]" />
              <div className="card-name">Tahfidz</div>
            </div>
          </div>

          <div className="card-grid">
            <div
              onClick={() =>
                navigate(
                  linkPage.FINANCE_REQUEST_VA.replace(":type", "monthly"),
                  {
                    state: {
                      tagihan: true,
                      tipe: "monthly",
                    },
                  }
                )
              }
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
              <FcMoneyTransfer className="card-icon tw-text-[#4D8EFF]" />
              <div className="card-name">Req. VA</div>
            </div>
          </div>

          <div className="card-grid">
            <div
              onClick={() =>
                navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "zis"), {
                  state: {
                    tagihan: false,
                    tipe: "zis",
                  },
                })
              }
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
              <FcMoneyTransfer className="card-icon tw-text-[#4D8EFF]" />
              <div className="card-name">VA ZIS</div>
            </div>
          </div>

          <div className="card-grid">
            <div
              onClick={() => navigate(linkPage.CHECKING_ACC_PAGE)}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
              <FcList className="card-icon" />
              <div className="card-name">Rek. Koran</div>
            </div>
          </div>

          <div className="card-grid">
            <div
              onClick={() => navigate(linkPage.MARKETPLACE_PRODUCT)}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#f5e9ff]" />
              <FcShop className="card-icon tw-text-accent-primary" />
              <div className="card-name">Toko</div>
            </div>
          </div>

          <div className="card-grid">
            <div
              onClick={() => navigate("/menu/other-menu")}
              className="tw-m-0"
            >
              <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
              <FcMenu className="card-icon" />
              <div className="card-name">Lainnya</div>
            </div>
          </div>
        </div>
      </div>
      {/* end of Menu */}

      {/* Mading */}
      {isPendingMading ? (
        <div className="tw-mt-5 tw-py-3 tw-m-auto tw-text-center">
          <Spiner className="" />
        </div>
      ) : (dataMading?.data ?? []).length === 0 ? (
        <></>
      ) : (
        <>
          <div className="tw-pb-20 tw-mt-2">
            <div className="tw-px-4 tw-pt-4 tw-pb-2 tw-flex tw-justify-between">
              <div className="tw-text-lg tw-font-medium tw-text-text-primary md:tw-text-2xl">
                Informasi Terkini
              </div>
              <div
                onClick={() => navigate("/mading/list")}
                className="tw-flex tw-items-center float-right tw-text-xs tw-text-warm-orange md:tw-text-sm"
              >
                Lihat Semua
              </div>
            </div>
            <Splide
              options={{
                perPage: 1,
                arrows: false,
              }}
              className="slider-no-dots"
            >
              {isPendingMading
                ? [1, 2, 3].map((key) => (
                    <SplideSlide key={key}>
                      <div
                        className="card tw-rounded-2xl tw-mx-2 tw-text-center tw-shadow-l tw-d-flex"
                        style={{ height: 289 }}
                      >
                        <Spiner className="" />
                      </div>
                    </SplideSlide>
                  ))
                : (dataMading?.data ?? [])
                    .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
                    .slice(0, 3)
                    .map((mading, idx) => (
                      <SplideSlide
                        className="tw-ps-4 tw-pe-2 !tw-w-8/12 tw-mb-4"
                        key={idx}
                        onClick={() => openDetailMading(mading)}
                      >
                        <div
                          className="tw-relative tw-p-4 tw-rounded-t-2xl tw-shadow-l tw-overflow-hidden tw-min-h-[150px]"
                          style={{
                            backgroundImage: `url(https://ponpes.darusunnahdlingo.com/assets/mading/${mading.gambar})`,
                            backgroundSize: "cover",
                          }}
                        ></div>
                        <div className="tw-bg-background-100/30 tw-backdrop-blur-lg tw-rounded-b-2xl tw-p-2 tw-border tw-border-background-200/50">
                          <div className="tw-px-2 tw-text-[10px] tw-font-light tw-text-text-primary">
                            {moment(mading.tanggal ?? Date.now()).format(
                              "dddd, DD MMMM YYYY"
                            )}
                          </div>
                          <div
                            className="tw-px-2 tw-mt-1 tw-text-md tw-font-medium tw-text-text-primary"
                            style={{
                              overflowWrap: "break-word",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {mading.judul}
                          </div>
                        </div>
                      </SplideSlide>
                    ))}
            </Splide>
          </div>
        </>
      )}
      {/* end of Mading */}
    </>
  );
};
